import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

const useStyles = makeStyles((theme) => ({
	root: {
		height: '80vh',
	},
}));

const PowerBIDashboard = (props) => {
	const { url, reportId, accessToken } = props;

	const classes = useStyles();
	useEffect(() => {
	}, [url]);

	if (!url) {
		return null;
	}

	return (
		<PowerBIEmbed
			embedConfig={{
				type: 'report', // Supported types: report, dashboard, tile, visual and qna
				id: reportId,
				embedUrl: url,
				accessToken,
				tokenType: models.TokenType.Aad,
				settings: {
					panes: {
						filters: {
							expanded: false,
							visible: true
						}
					},
					background: models.BackgroundType.Default,
				}
			}}
			/* eventHandlers={
				new Map([
					['loaded', () => { console.log('Report loaded'); }],
					['rendered', () => { console.log('Report rendered'); }],
					['error', (event) => { console.log(event.detail); }]
				])
			} */
			cssClassName={classes.root}
			getEmbeddedComponent={(embeddedReport) => {
				window.report = embeddedReport;
			}}
		/>
	);
};

PowerBIDashboard.propTypes = {
	url: PropTypes.string.isRequired,
	reportId: PropTypes.string.isRequired,
	accessToken: PropTypes.string.isRequired
};

export default PowerBIDashboard;
